import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InView } from 'react-intersection-observer'
import { selectExhibit } from './features/exhibitReducer'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { CardMedia } from '@material-ui/core'
import { highlightPin } from './features/pinsReducer'
import { setCenter, setZoom } from './features/mapReducer'
import { grey } from '@material-ui/core/colors'


function StartCard(props, classes) {
  const exhibit  = useSelector(selectExhibit)
  const dispatch = useDispatch()
  const center = exhibit.mapCenterAddressCoords
  const zoom = exhibit.mapZoom

  const nameStyle = {
    lineHeight: '.90em',
    fontWeight: 700,
    color: exhibit.mainColor,
  }

  const descriptionStyle = {
    lineHeight: '1.25em',
    paddingTop: 24,
    paddingBottom: 24,
  }

  const exhibitImage = {
    maxWidth: '345px',
    maxHeight: 'auto',
  }



  return (
    <InView threshold={ .1 }
            rootMargin={'0px 0px -60% 2px'}
            onChange={(inView, entry) => {
              if(inView){
                dispatch(highlightPin(-1))
                dispatch(setZoom(zoom))
                dispatch(setCenter(center))
              }
            }}>
      <Card elevation={0}
            square={true}
      >
        <CardContent>
          <Typography variant="h2" className={classes.title}>
            <div style={nameStyle}>{exhibit.name}</div>
          </Typography>
          <Typography variant="subtitle1" className={classes.description} style={{ color: grey[900] }}>
            <p style={descriptionStyle}>{exhibit.description}</p>
          </Typography>
          <CardMedia className={classes.media}>
            <img alt={"exhibit"} src={exhibit.image} style={exhibitImage} />
          </CardMedia>
        </CardContent>
      </Card>
    </InView>
  )
}

export default StartCard
